var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRotateIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 61,
    viewBox: "0 0 60 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5611 41.3467C18.8943 41.3467 10.9851 37.48 10.9851 32.5587C10.9851 28.692 16.0821 25.3525 23.2883 24.1222V18.4979L30.3187 25.5283L23.2883 32.5587V27.8132C17.664 28.8677 14.5003 31.1526 14.5003 32.5587C14.5003 34.492 19.7731 37.8315 28.5611 37.8315C37.3491 37.8315 42.6219 34.492 42.6219 32.5587C42.6219 31.3284 39.9855 29.2192 35.5915 28.1647V24.4737C41.7431 25.8798 46.1371 28.8677 46.1371 32.5587C46.1371 37.48 38.2279 41.3467 28.5611 41.3467Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotateIcon);
export default __webpack_public_path__ + "static/media/rotateIcon.229768d14e45b5bef94e2fa7c3dced87.svg";
export { ForwardRef as ReactComponent };